import { CSSProperties } from "react"
import { C, radius, shadow } from "@/theme/newDesignTokens"

export const styles: Record<string, CSSProperties> = {
    page: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: C.pageBg,
        padding: 24,
    },
    card: {
        backgroundColor: C.white,
        borderRadius: radius.xl,
        boxShadow: shadow.md,
        maxWidth: 480,
        width: "100%",
        padding: 48,
        textAlign: "center",
    },
    logo: {
        height: 40,
        objectFit: "contain",
        marginBottom: 24,
    },
    heading: {
        fontSize: "1.5rem",
        fontWeight: 700,
        color: C.navyDark,
        margin: "0 0 12px",
    },
    paragraph: {
        fontSize: "0.95rem",
        lineHeight: 1.6,
        color: C.medGray,
        margin: "0 0 8px",
    },
    spinner: {
        marginTop: 24,
        display: "flex",
        justifyContent: "center",
    },
}
